module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/tile_sports-434baa5be066a62dbca873711bc31979.jpg";